const generateStickyPageContents = () => {
  const contents = document.querySelector('.wmnds-page-contents');
  if (contents !== null) {
    const contentsParent = contents.closest('.wmnds-third-1-3');
    contentsParent.classList.add('wmnds-sticky');
  }
};

export default generateStickyPageContents;
